import i18n from '../languages/i18n.js';

const enums = {
  activityStatus: {
    1: i18n.t('global.待审核'),
    2: i18n.t('global.进行中'),
    3: i18n.t('global.审核未通过'),
    4: i18n.t('global.已结束'),
    5: i18n.t('global.进行中')
  },
  gender: {
    0: i18n.t('global.保密'),
    1: i18n.t('global.男'),
    2: i18n.t('global.女')
  }
};

export default enums;



// WEBPACK FOOTER //
// ./src/util/enum.js